module.exports = __webpack_public_path__ + "img/Gokayu.32b22251.jpg";